export default __webpack_public_path__ + "static/media/9 (1).f11e04af.jpg";